import { sectionGeometry } from "../../shared/section";

/**
 * Traces saved before 18Sep26 placed "Any Other Point" ON the tunnel surface,
 * by its location relative to the SPL: on the crown at offset d ("above"), at
 * the SPL corner ("at"), or on the wall Hp below the SPL ("below"). The
 * Algorithm Navigator (17Sep26) gives it as a point on the face instead: side,
 * offset d and height Hp above the invert.
 *
 * Rewrites one saved trace into the new fields so it plots where it did.
 * `geometry` is the first trace, which fixes the section for the whole log.
 * Pure: returns a new object, and leaves traces without the old field alone.
 */
export function migrateLegacyFacePoint(dim, geometry = dim) {
  if (!dim || dim.locationwrtSPL === undefined) return dim;
  const { locationwrtSPL, ...next } = dim;
  if (next.orientation !== "otherpoint" || !locationwrtSPL) return next;

  const g = sectionGeometry(geometry, { battered: true });
  const oldHp = Number(dim.verticalheight) || 0;
  let d = Math.abs(Number(dim.distancefromcenter) || 0);
  let Hp;
  if (locationwrtSPL === "above") {
    d = Math.min(d, g.WS / 2);
    Hp = g.HWn + Math.sqrt(Math.max(0, g.R * g.R - d * d));
  } else if (locationwrtSPL === "below") {
    Hp = Math.max(0, Math.min(g.HW, g.HW - oldHp));
    d = g.W / 2 + ((g.WS - g.W) / 2 / g.HW) * Hp;
  } else {
    d = g.WS / 2;
    Hp = g.HW;
  }
  const round2 = (v) => Math.round(v * 100) / 100;
  return {
    ...next,
    tunnelside: next.tunnelside === "right" ? "right" : "left",
    distancefromcenter: round2(d),
    verticalheight: round2(Hp),
  };
}
